import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@app/App'
import '@styles/index.css'
import "./styles/theme/common-form.css";

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element with id "root" was not found in the document.')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
